let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("at9PL")).then(() => parcelRequire('aKJ2P'));